import React, { Component, PropsWithChildren } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import './Modal.scss'

interface IModalProps extends WithTranslation, PropsWithChildren {
  onClose: () => void
  visible: boolean
  hideCloseBtn?: boolean
  title?: string
  icon?: string
  resetbtn?: boolean
  resetOrder?: () => void
  detailsCustomClass?: string
}

interface IModalState {
  visible: boolean
  render: boolean
}

class Modal extends Component<IModalProps, IModalState> {
  constructor(props: IModalProps) {
    super(props)

    this.state = {
      render: this.props.visible,
      visible: this.props.visible,
    }
  }
  componentDidUpdate(prevProps: IModalProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        this.setState({
          render: true,
        })

        setTimeout(() => {
          this.setState({
            visible: !this.state.visible,
          })
        }, 100)
      } else {
        this.setState({
          visible: false,
        })
        setTimeout(() => {
          this.setState({
            render: false,
          })
        }, 200)
      }
    }
  }

  onOverlayClick() {
    this.onClose()
  }

  onBodyClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e.stopPropagation()
  }

  onClose() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const { title, t, resetbtn, resetOrder } = this.props
    const { render, visible } = this.state

    if (!render) {
      return null
    }

    return (
      <div
        translate="no"
        onClick={() => this.onOverlayClick()}
        className={`modal-overlay ${visible ? 'visible' : 'hidden'}`}
      >
        <div onClick={(e) => this.onBodyClick(e)} className="modal-body">
          <div className="contractFilters reqFilters">
            <div className="leftContainer">
              <div className="reqTitle">
                <i className={this.props.icon ? this.props.icon : 'icon-info'} />
                {title && <span translate="no">{title}</span>}
              </div>
            </div>
            {resetbtn && resetOrder && (
              <div className="rightFilters">
                <a onClick={() => resetOrder()}>
                  <span className="icon-eye"></span>
                  <i className="icon-clear"></i> <span>{t('RESTORE_DEFAULT')}</span>
                </a>
              </div>
            )}
            <button title={t('CLOSE')} onClick={() => this.onClose()}>
              <i className="icon-close" />
            </button>
          </div>
          <div className={`details ${this.props.detailsCustomClass ? this.props.detailsCustomClass : ''}`}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('common')(Modal)
